import { Box, IconButton, Paper, styled } from "@mui/material"

export const UMWrapper = styled(Box)({
  backgroundColor: "#F8F9FA",
  // border: "1px solid red",
  height: "100%",
})

export const UMPaper = styled(Paper)({
  margin: "0px 24px",
  display: "flex",
  flexDirection: "column",
  flexGrow: 1,
  border: "4px 4px 4px 4px",
  height: "78vh",
  overflow: "auto",
})

export const StyledRCPaper = styled(Paper)({
  display: "flex",
  gap: 1,
  alignItems: "stretch",
  justifyContent: "space-between",
  cursor: "pointer",
})

export const SqaureIconButton = styled(IconButton)({
  borderRadius: "0",
  margin: "0",
  //   "& .MuiTouchRipple-root .MuiTouchRipple-child": {
  //     borderRadius: "0px",
  //   },
})
